/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  padding: 0 calc(8rem /14);
  margin-right: calc(16rem /14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  border: 1px solid;
  border-color: #8E989D;
  border-color: var(--davinci-color-outline, #8E989D);
}
:host .wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
}
:host .wrapper .icon {
  width: calc(18rem /14);
  height: calc(18rem /14);
  fill: #2C3133;
  fill: var(--davinci-color-text, #2C3133);
}
:host .wrapper .slotwrapper {
  font-size: calc(12rem /14);
  line-height: calc(24rem /14);
  flex: 1 1 auto;
}
:host .wrapper > .close {
  display: none;
  flex: 0 0 auto;
  width: calc(16rem /14);
  height: calc(16rem /14);
  margin-top: calc(1rem /14);
  margin-left: calc(16rem /14);
  cursor: pointer;
}
:host .wrapper > .close svg {
  width: calc(16rem /14);
  height: calc(16rem /14);
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host .wrapper > .close:focus {
  outline: none;
}

:host([type=filter]) .close {
  display: block;
}

:host([type=filter]:focus),
:host([type=filter]:hover) {
  border-color: #737F85;
  border-color: var(--davinci-color-text-lighter, #737F85);
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host([type=filter]:focus) .close svg,
:host([type=filter]:hover) .close svg {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}

:host([hidden]) {
  display: none;
}`;
export { style };
